// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TableColumn } from "./TableColumn";
import {
  TableColumnFromJSON,
  TableColumnFromJSONTyped,
  TableColumnToJSON,
  TableColumnToJSONTyped,
} from "./TableColumn";

/**
 *
 * @export
 * @interface Table
 */
export interface Table {
  /**
   *
   */
  layerId: string;
  /**
   *
   */
  tableId: string;
  /**
   *
   */
  columns: { [key: string]: TableColumn };
}

/**
 * Check if a given object implements the Table interface.
 */
export function instanceOfTable(value: object): value is Table {
  if (
    (!("layerId" in (value as Record<string, any>)) &&
      !("layer_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["layerId"] === undefined &&
      (value as Record<string, any>)["layer_id"] === undefined)
  )
    return false;
  if (
    (!("tableId" in (value as Record<string, any>)) &&
      !("table_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tableId"] === undefined &&
      (value as Record<string, any>)["table_id"] === undefined)
  )
    return false;
  if (!("columns" in value) || value["columns"] === undefined) return false;
  return true;
}

export function TableFromJSON(json: any): Table {
  return TableFromJSONTyped(json, false);
}

export function TableFromJSONTyped(json: any, ignoreDiscriminator: boolean): Table {
  if (json == null) {
    return json;
  }
  return {
    layerId: json["layer_id"],
    tableId: json["table_id"],
    columns: mapValues(json["columns"], TableColumnFromJSON),
  };
}

export function TableToJSON(json: any): Table {
  return TableToJSONTyped(json, false);
}

export function TableToJSONTyped(value?: Table | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    layer_id: value["layerId"],
    table_id: value["tableId"],
    columns: mapValues(value["columns"], TableColumnToJSON),
  };
}
